import React, { useState } from 'react'
import { useJsonItem } from './JsonItemProvider'
import { Label } from '../ui/label'
import { useTranslation } from '~/hooks/useTranslation'

const YearMonthSelect = ({ value, onChange, onBlur, id }) => {
  const { t } = useTranslation('JsonYearMonthField.months')
  const [yyyy, mm] = value.split('-')
  const [year, setYear] = useState(yyyy || '')
  const [month, setMonth] = useState(mm || '')
  const years = Array.from(
    { length: 60 },
    (_, i) => new Date().getFullYear() - i,
  )
  const months = [
    [t('january'), '01'],
    [t('february'), '02'],
    [t('march'), '03'],
    [t('april'), '04'],
    [t('may'), '05'],
    [t('june'), '06'],
    [t('july'), '07'],
    [t('august'), '08'],
    [t('september'), '09'],
    [t('october'), '10'],
    [t('november'), '11'],
    [t('december'), '12'],
  ]

  const yearChange = (e) => {
    const newYear = e.target.value
    setYear(newYear)
    const paddedMonth = String(month).padStart(2, '0')
    const newDate = month != '' ? `${newYear}-${paddedMonth}` : String(newYear)
    if (newYear == '') {
      onChange({ target: { value: '' } })
    } else {
      onChange({ target: { value: newDate } })
    }
  }

  const monthChange = (e) => {
    const newMonth = e.target.value
    setMonth(newMonth)
    const paddedMonth = String(newMonth).padStart(2, '0')
    const newDate = newMonth != '' ? `${year}-${paddedMonth}` : String(year)
    if (year == '') {
      onChange({ target: { value: '' } })
    } else {
      onChange({ target: { value: newDate } })
    }
  }

  const selectClasses = 'border-input bg-input-background rounded-md inline'

  return (
    <div className="flex flex-row">
      {/* CTS-9213 — select-name: year/month selects were unlabeled */}
      <select
        id={id}
        value={year}
        onChange={yearChange}
        onBlur={onBlur}
        aria-label={t('year_label')}
        className={selectClasses}
      >
        <option></option>
        {years.map((y) => (
          <option key={y} value={y}>
            {y}
          </option>
        ))}
      </select>
      <select
        id={id && `${id}-month`}
        value={month}
        onChange={monthChange}
        onBlur={onBlur}
        aria-label={t('month_label')}
        style={{ marginLeft: '0.5rem' }}
        className={selectClasses}
      >
        <option></option>
        {months.map((m) => (
          <option key={m[1]} value={m[1]}>
            {m[0]}
          </option>
        ))}
      </select>
    </div>
  )
}

const JsonYearMonthField = ({
  containerClassName,
  label,
  fieldName,
  childField,
  handleItemUpdate = null,
  getItemValue = null,
}) => {
  const { index, sectionName, item, setItem, updateItem } = useJsonItem()

  const id = [sectionName, fieldName, childField, index].join('-')

  const onBlur = () => {
    updateItem()
  }

  const onChange = (event) => {
    const value = event.target.value || ''

    const updatedItem = handleItemUpdate
      ? handleItemUpdate(item, value)
      : childField
        ? { ...item, [fieldName]: { ...item[fieldName], [childField]: value } }
        : { ...item, [fieldName]: value }
    setItem(updatedItem)
  }

  const itemValue = getItemValue
    ? getItemValue(item)
    : childField
      ? item[fieldName]
        ? item[fieldName][childField]
        : ''
      : item[fieldName] || ''

  return (
    <div className={containerClassName}>
      <Label htmlFor={id}>{label}</Label>
      <YearMonthSelect
        id={id}
        onBlur={onBlur}
        value={itemValue}
        onChange={onChange}
      />
    </div>
  )
}
export default JsonYearMonthField
